import React,{useState,useEffect} from "react";
import KioskLayout from "components/Layout/KioskLayout";
import KioskShopList from "components/Kiosk/Shop/KioskShopList";
import FilterSection from "components/shared/FilterSection";
import useFetch from "hooks/useFetch";
import { useSelector } from "react-redux";
import useGetFloorLvl from "hooks/useGetFloorLvl";
import useGaPageView from "hooks/useGaPageView";
import MapRouterMaster from "containers/MapRouterMaster";
import { mapRouterType, screenKeys, gaSettings, mapCatIdToKioskType } from "config/constants";
import { mainApiPath } from "api/constants";
import Axios from "axios";

const KioskShop = (props) => {
  const [error, loading, data] = useFetch(mainApiPath.store);
  const floorLevel = useGetFloorLvl();

  const catState = useSelector((state) => state.filter.filterByCategory);
  let gaTitle = null;
  let gaLocation = null;
  if (catState.id) {
    const shopType = mapCatIdToKioskType[catState.id];
    gaTitle = shopType ? gaSettings[shopType].title : gaSettings.unknown.title;
    gaLocation = shopType ?  gaSettings[shopType].location : gaSettings.unknown.location;;
  }
  useGaPageView({ gaTitle, gaLocation });

  return (
    <KioskLayout
      error={error}
      loading={loading}
      goBack={screenKeys.kiosk}
      left={
        <>
          <MapRouterMaster
            type={mapRouterType.overview}
            floorIndex={floorLevel}
            layout={"kiosk"}
          />
          <FilterSection
            loading={loading}
            floors={data ? data.floors : null}
            search
            floorfilter
          />
        </>
      }
      right={
        <KioskShopList shops={data ? data.list : null} loading={loading} />
      }
    />
  );
};

export default KioskShop;
